import { render, staticRenderFns } from "./TokenizerForm.vue?vue&type=template&id=96ad645e&"
import script from "./TokenizerForm.vue?vue&type=script&lang=js&"
export * from "./TokenizerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96ad645e')) {
      api.createRecord('96ad645e', component.options)
    } else {
      api.reload('96ad645e', component.options)
    }
    module.hot.accept("./TokenizerForm.vue?vue&type=template&id=96ad645e&", function () {
      api.rerender('96ad645e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/components/TokenizerForm.vue"
export default component.exports